// src/components/OtpModal.js
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import LoadingContainer from '../../components/Loading/Loading';

const OtpModal = ({ show, handleClose, handleOtpSubmit, loading }) => {
  const [otp, setOtp] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    handleOtpSubmit(otp);
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>إدخال OTP</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <LoadingContainer /> // عرض LoadingContainer إذا كان loading = true
        ) : (
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formOtp">
              <Form.Label>OTP</Form.Label>
              <Form.Control
                type="text"
                placeholder="أدخل OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? 'جاري التحميل...' : 'تأكيد'}
            </Button>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default OtpModal;